import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import { getRegionalUsersByUserIds } from '../../regional-user'
import type { RegionalUser } from '../../user.interface'

const EMPTY_REGIONAL_USERS: RegionalUser[] = []

function buildRegionalUsersById(users: RegionalUser[]): Map<string, RegionalUser> {
  return new Map(users.map((user) => [user.userId, user]))
}

export function useRegionalUsersByIds(userIds: string[]): Map<string, RegionalUser> {
  const sortedIds = useMemo(() => Array.from(new Set(userIds.filter(Boolean))).sort(), [userIds])

  const { data = EMPTY_REGIONAL_USERS } = useQuery({
    queryKey: ['regional-users-by-ids', sortedIds],
    queryFn: () => getRegionalUsersByUserIds(sortedIds),
    enabled: sortedIds.length > 0,
  })

  return useMemo(() => buildRegionalUsersById(data), [data])
}
